import { useSyncExternalStore } from 'react';

/** Whether a CSS media query matches, kept current (constants/layout MEDIA holds the queries). */
export function useMediaQuery(query: string) {
  return useSyncExternalStore(
    (onChange) => {
      const m = window.matchMedia(query);
      m.addEventListener('change', onChange);
      return () => m.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
